"use client";

import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import CampusCard from "./CampusCard";
import {useCampusContext} from "@/app/_components/contexts/CampusCookieContext";

const CookieCampusCard: FCWithHTMLAttributes = ({className}) => {
	const {campus} = useCampusContext();

	return <CampusCard campus={campus} className={className} />;
};

export default CookieCampusCard;
